import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { adminRetrieveProviders } from "@user-management-context/read/application/use-cases/admin/providers-retrieval/retrieve-providers";
import type { ProviderListItemVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<ProviderListItemVM[]> = { data: [], fetching: "idle" };

export const adminRetrieveProvidersReducer = createReducer<RetrievalState<ProviderListItemVM[]>>(initialState, builder => {
  builder.addCase(adminRetrieveProviders.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(adminRetrieveProviders.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(adminRetrieveProviders.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
